import React, { useEffect, useState } from 'react';

const ImagePreview = ({ file,Id }) => {
    const [preview,setPreview]=useState()
    // console.log("File",file);
    
  const renderFile = (f) => {
    if (f) {
      const reader = new FileReader();

      reader.onloadend = () => {
          setPreview(reader.result)
      };

      reader.readAsDataURL(f);
    }
  };

  useEffect(() => {
    renderFile(file);
  }, [file]);

  if (file) {
      return <img id={Id} src={preview} alt="Preview" style={{width:"100%", height:"100%", objectFit:"contain"}} />;
  }
};

export default ImagePreview;
